import { PH_HOST, USA_HOST, SG_HOST, MY_HOST, VN_HOST } from "config";

function getContactNumbers() {
  return ["8423-9143", "7730-2059"];
}
function getLoyaltyGuideLink() {
  return "http://bit.ly/zaployalty101";
}

function getCurrencyClass() {
  switch (document.domain) {
    case USA_HOST:
    case SG_HOST:
      return "currency-Dollar";
    case MY_HOST:
      return "currency-Ringgit";
    case VN_HOST:
      return "currency-Dong";
    default:
      return "currency-Peso";
  }
}

function isPhDomain() {
  return document.domain === PH_HOST;
}

function isUSADomain() {
  return document.domain === USA_HOST;
}

function isSGDomain() {
  return document.domain === SG_HOST;
}

function isMyDomain() {
  return document.domain === MY_HOST;
}

function isVnDomain() {
  return document.domain === VN_HOST;
}

function showAppSection() {
  return (
    isPhDomain() ||
    isUSADomain() ||
    isSGDomain() ||
    isMyDomain() ||
    isVnDomain()
  );
}

function showFooterCareers() {
  return isPhDomain();
}

function showProfileZapcash() {
  return isPhDomain();
}

export {
  isPhDomain,
  getContactNumbers,
  getCurrencyClass,
  getLoyaltyGuideLink,
  showAppSection,
  showFooterCareers,
  showProfileZapcash,
};



// WEBPACK FOOTER //
// ./js/components/helpers/domainSettings.js